import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PdfFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.77427 19.823C2.77678 21.4403 4.08211 22.75 5.69144 22.75H17.3328C18.5256 22.75 19.5512 22.0306 20.0033 21H9.5C8.39543 21 7.5 20.1046 7.5 19V14C7.5 12.8954 8.39543 12 9.5 12H20.25V9.05498C20.25 8.79546 20.1473 8.5466 19.9645 8.36329L13.1564 1.53551C12.9741 1.35268 12.7271 1.25 12.4695 1.25H5.66717C4.05429 1.25 2.74749 2.56532 2.75 4.18619L2.77427 19.823ZM12.0673 3.20594L18.3043 9.46094H13.5673C12.7389 9.46094 12.0673 8.78936 12.0673 7.96094V3.20594Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9875 15.0125C11.3395 15.0125 11.625 15.2979 11.625 15.65C11.625 16.0021 11.3395 16.2875 10.9875 16.2875H10.35V15.0125H10.9875ZM9.07495 14.375C9.07495 14.2117 9.13633 14.0628 9.23728 13.95C9.35401 13.8196 9.52365 13.7375 9.71245 13.7375H10.9875C11.4429 13.7375 11.8612 13.8967 12.1896 14.1625C12.6229 14.5131 12.9 15.0492 12.9 15.65C12.9 15.8735 12.8616 16.0881 12.7911 16.2875C12.5286 17.0303 11.8202 17.5625 10.9875 17.5625H10.35V18.625C10.35 18.9771 10.0645 19.2625 9.71245 19.2625C9.36037 19.2625 9.07495 18.9771 9.07495 18.625V14.375Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3875 13.7375C14.0354 13.7375 13.75 14.0229 13.75 14.375V18.625C13.75 18.9771 14.0354 19.2625 14.3875 19.2625H15.4803C16.6201 19.2625 17.575 18.3596 17.575 17.2083V15.7917C17.575 14.6404 16.6201 13.7375 15.4803 13.7375H14.3875ZM16.2098 17.5625C16.0767 17.81 15.8075 17.9875 15.4803 17.9875H15.025V15.0125H15.4803C15.95 15.0125 16.3 15.3782 16.3 15.7917V17.2083C16.3 17.3337 16.2678 17.4547 16.2098 17.5625Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0625 19.2625C19.137 19.2625 19.2085 19.2497 19.275 19.2262C19.5226 19.1387 19.7 18.9025 19.7 18.625V17.1375H21.1875C21.5395 17.1375 21.825 16.8521 21.825 16.5C21.825 16.1479 21.5395 15.8625 21.1875 15.8625H19.7V15.0125H21.6125C21.9645 15.0125 22.25 14.7271 22.25 14.375C22.25 14.0229 21.9645 13.7375 21.6125 13.7375H19.0625C18.7104 13.7375 18.425 14.0229 18.425 14.375V18.625C18.425 18.9771 18.7104 19.2625 19.0625 19.2625Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PdfFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PdfFilledIcon;
